// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Files = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Files = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Files = _exports.Files = function Files(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M2.28516 7.49996V4.60713C2.28516 4.18089 2.45448 3.77211 2.75587 3.47072C3.05727 3.16932 3.46605 3 3.89229 3H6.94141C7.25874 3.00001 7.56896 3.09395 7.83297 3.27L8.95153 4.01571C9.21554 4.19175 9.52576 4.2857 9.84309 4.2857H16.1065C16.5327 4.2857 16.9415 4.45503 17.2429 4.75642C17.5443 5.05782 17.7136 5.4666 17.7136 5.89283V7.49996",
      stroke: "#212B36",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M18.9959 8.88816L18.3442 15.5357C18.3442 15.9614 18.1753 16.3698 17.8745 16.6711C17.5737 16.9724 17.1657 17.142 16.7399 17.1428H3.2601C2.83435 17.142 2.42629 16.9724 2.1255 16.6711C1.82472 16.3698 1.65578 15.9614 1.65578 15.5357L1.00409 8.88816C0.989946 8.71124 1.01258 8.53331 1.07058 8.36557C1.12858 8.19784 1.22067 8.04392 1.34107 7.91352C1.46147 7.78312 1.60756 7.67906 1.77015 7.6079C1.93273 7.53673 2.10829 7.49999 2.28578 7.5H17.7182C17.8954 7.50054 18.0705 7.53769 18.2326 7.6091C18.3947 7.68051 18.5403 7.78466 18.6603 7.915C18.7803 8.04534 18.872 8.19906 18.9297 8.36652C18.9875 8.53399 19.01 8.71158 18.9959 8.88816V8.88816Z",
      stroke: "#212B36",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }));
  };
});
